module.exports = __webpack_public_path__ + "web/img/chapter-40.ce66a921.png";